import type { PlaceSuggestion } from "./types";

export function isCountryDestination(place: PlaceSuggestion | null) {
  if (!place) return false;
  const kind = [place.feature_code, place.category, place.suggestion_kind]
    .filter(Boolean).join(" ").toLowerCase();
  return kind === "country" || kind.includes(" country") || /^pcl[a-z]*$/i.test(place.feature_code || "");
}

export function uniqueRoutePlaces(places: Array<PlaceSuggestion | null>) {
  const seen = new Set<string>();
  return places.filter((place): place is PlaceSuggestion => {
    if (!place || seen.has(place.provider_id)) return false;
    seen.add(place.provider_id);
    return true;
  });
}
